<template>
  <el-dialog custom-class="dialog-size-middle"
             :title="label + 'データ一覧'"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="upload-file-list-container">
      <fixed-header-table :fixed="true">
        <tr slot="header">
          <th>{{label}}データ名</th>
          <th class="col-file-size">ファイルサイズ</th>
          <th class="col-import-date" style="flex-grow: 0; min-width: 160px; max-width: 160px;">インポート日時</th>
          <th style="flex-grow: 0; min-width: 100px; max-width: 100px;"></th>
          <th style="flex-grow: 0; min-width: 100px; max-width: 100px;"></th>
        </tr>
        <tr v-for="uploadFile in innerUploadFiles">
          <td>{{uploadFile.originalFileName}}</td>
          <td class="col-file-size">{{uploadFile.fileSizeByte | file_size}}</td>
          <td style="flex-grow: 0; justify-content: center; min-width: 160px; max-width: 160px;">
            <span v-if="uploadFile.importId">{{uploadFile.importedAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD HH:mm')}}</span>
            <span v-else style="text-align: center; width: 100%;">-</span>
          </td>
          <td style="flex-grow: 0; justify-content: center; min-width: 100px; max-width: 100px;">
            <el-button v-if="uploadFile.importId" type="primary" @click="onClickReImport(uploadFile)">
              <font-awesome-icon class="icon sync-alt" icon="sync-alt"/>
            </el-button>
            <span v-else style="text-align: center; width: 100%;">-</span>
          </td>
          <td style="flex-grow: 0; justify-content: center; min-width: 100px; max-width: 100px;">
            <el-button type="danger" @click="onClickRemove(uploadFile)">
              <font-awesome-icon class="icon delete" icon="trash-alt"/>
            </el-button>
          </td>
        </tr>
      </fixed-header-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickOk(true)">OK</el-button>
    </span>
  </el-dialog>
</template>

<script lang="js">
import { default as ApiApiClient } from '../../../../../api/api'
import MessageBox from '../../../../../utils/message-box'
import Messages from '../../../../../utils/messages'
import CommonUtil from '../../../../../utils/common'
import { Code } from '../../../../../api/base'

export default {
  name: 'UploadFileListDialogCmp',
  components: {},
  props: {
    uploadFiles: [],
    method: '',
    modelId: '',
    label: ''
  },
  model: {
    prop: 'uploadFiles',
    event: 'change'
  },
  data () {
    return {
      innerUploadFiles: [],
      visible: true
    }
  },
  created () {
    const srcUploadFiles = this.uploadFiles
    this.innerUploadFiles = srcUploadFiles.slice(0, srcUploadFiles.length)
  },
  methods: {
    onClickRemove (uploadFile) {
      const innerUploadFiles = this.innerUploadFiles
      innerUploadFiles.splice(innerUploadFiles.indexOf(uploadFile), 1)
    },
    onClickReImport (uploadFile) {
      MessageBox.confirm(this, `${this.label}データを再インポートしますか？`).then(() => {
        ApiApiClient.reImportDs(this, {
          method: this.method,
          modelId: this.modelId,
          importId: uploadFile.importId
        }).then((response) => {
          const code = response.data.code
          if (code === Code.SUCCESS) {
            const newUploadFile = {
              dsName: response.data.ds_name,
              fileSizeByte: response.data.file_size_byte,
              fileName: response.data.file_name,
              originalDsName: response.data.ds_name,
              originalFileName: response.data.file_name,
              originalFileSizeByte: response.data.file_size_byte,
              importId: response.data.import_id,
              importedAt: response.data.imported_at
            }
            const innerUploadFiles = this.innerUploadFiles
            innerUploadFiles.splice(innerUploadFiles.indexOf(uploadFile), 1, newUploadFile)
          } else {
            if (/^21\d{2}$/.test(code)) {
              const messageArgs = response.data.message_args
              messageArgs.splice(0, 0, this.label)
              const message = CommonUtil.isNotEmpty(code) ? Messages.getMessage(code, messageArgs) : null
              MessageBox.alert(this, message || '再インポートに失敗しました。', {
                dangerouslyUseHTMLString: true
              }).then(() => {
                // NOP
              }).catch(() => {})
            }
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    onClickOk () {
      this.$emit('change', this.innerUploadFiles)
      this.visible = false
    }
  }
}

</script>

<style scoped>
  .upload-file-list-container {
    display: flex;
    flex-grow: 1;
  }

  .col-file-size {
    flex-grow: 0;
    min-width: 200px;
    max-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/upload-ds/dialogs/upload-file-list.vue